import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NumericInput from 'react-numeric-input';

import DynamicDataGrid from '../../common/DynamicDataGrid/DynamicDataGrid';
import { numberWithCommas } from '../../../util/CommonUtils';
import FunctionBoxButtonGroup from './FunctionBoxButtonGroup';

const commaFormatter = ({ value }) => <div>{numberWithCommas(value)}</div>;

commaFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

class FunctionBoxCount extends Component {
  static getColumns() {
    return [
      { key: 'count', name: 'Count', sortable: true, width: 100 },
      {
        key: 'frequency',
        name: 'Frequency',
        sortable: true,
        width: 150,
        formatter: commaFormatter,
      },
      {
        key: 'cumulativeFrequencyAsc',
        name: 'Cumulative Frequency Ascending',
        sortable: true,
        width: 225,
        formatter: commaFormatter,
      },
      {
        key: 'cumulativeFrequencyDesc',
        name: 'Cumulative Frequency Descending',
        sortable: true,
        width: 225,
        formatter: commaFormatter,
      },
    ];
  }

  constructor(props) {
    super(props);

    const rowsData = this.props.sampleWeightedValues
      ? this.getRowsData(this.props.sampleWeightedValues)
      : [];

    this.state = {
      lowerBound: 0,
      upperBound: rowsData.length > 0 ? rowsData.length - 1 : 0,
      rowsData,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.sampleWeightedValues &&
      this.props.sampleWeightedValues !== nextProps.sampleWeightedValues
    ) {
      const rowsData = this.getRowsData(nextProps.sampleWeightedValues);
      this.setState({
        lowerBound: 0,
        upperBound: rowsData.length > 0 ? rowsData.length - 1 : 0,
        rowsData,
      });
    }
  }

  getRowsData = sampleWeightedValues => {
    if (sampleWeightedValues.length > 0) {
      const cFrequencyAscList = [];
      let tmpCFrequency = 0;
      const frequencyList = sampleWeightedValues.map(item => {
        tmpCFrequency += item.weighted;
        cFrequencyAscList.push(tmpCFrequency);
        return item.weighted;
      });

      const rowsData = frequencyList.map((frequency, index) => {
        const returnObj = {
          count: index,
          cumulativeFrequencyAsc: cFrequencyAscList[index],
          cumulativeFrequencyDesc: tmpCFrequency,
          frequency,
        };
        tmpCFrequency -= frequency;
        return returnObj;
      });

      return rowsData;
    }
    return [];
  };

  createExpression = () => {
    const expressionKeyword = this.props.selectedTargets.reduce(
      (acc, item) => `${acc} ${item.keyword} , `,
      'COUNTRANGE (',
    );

    return `${expressionKeyword} ${this.state.lowerBound} , ${
      this.state.upperBound
    } )`;
  };


  createSmartSearchArray = () => {
    const selectedTargets = _.cloneDeep(this.props.selectedTargets);
    const objSmartSearchArray = {};
    const objectsAdded = [];
    const expressionFormed = [];
    const tags = [];

    selectedTargets.forEach(target => {
      const breadcrumbList = JSON.parse(window.localStorage.getItem('breadCrumb'));
      const breadCrumbValue = breadcrumbList ? breadcrumbList.reverse().join(' > ') : undefined;

      target.breadcrumbs = breadCrumbValue;
      objectsAdded.push(target);
      expressionFormed.push(target.keyword);
      tags.push(target.shortText);
    });
    objSmartSearchArray.objectsAdded = objectsAdded;
    objSmartSearchArray.expressionFormed = expressionFormed;
    objSmartSearchArray.tags = tags;

    return objSmartSearchArray;
  }


  moveAppendToCodingBox = isMove =>
    this.props.moveAppendToCodingBox(isMove, this.createExpression(), this.createSmartSearchArray());

  moveToColumns = () => {
    if (this.props.functionTitle) {
      this.props.moveToColumns(this.createExpression(), this.createSmartSearchArray());
    } else {
      this.props.moveToColumns();
    }
  };

  moveToRows = () => {
    if (this.props.functionTitle) {
      this.props.moveToRows(this.createExpression(), this.createSmartSearchArray());
    } else {
      this.props.moveToRows();
    }
  };

  addToDefinitionModal = () => {
    if (this.props.functionTitle) {
      this.props.addToDefinition(this.createExpression());
    } else {
      this.props.addToDefinition();
    }
  };

  render() {
    return (
      <div className="function-box-count">
        <div className="row expanded">
          <div className="small-12 medium-8 large-9 columns padding-left-0">
            <DynamicDataGrid
              gridCategory="FunctionBoxGrid"
              className="saved-crosstab-grid"
              gridHeight={320}
              gridWidth={700}
              headerRowHeight={80}
              rows={this.state.rowsData}
              columns={this.constructor.getColumns()}
              rowSelectionType="Single"
              isCellSelectable
              minimunRows={8}
            />
          </div>
          <div className="small-12 medium-3 large-3 columns function-position">
            <div className="row">
              <div className="numeric-input-text">
                <label htmlFor="lower-bound" className="float-right">
                  Lower Bound {'>=:'}{' '}
                </label>
              </div>
              <div className="numeric-input-control">
                {/* <NumericInput
                  min={0}
                  max={this.state.upperBound}
                  value={this.state.lowerBound}
                  className="form-control"
                  onChange={() => this.setState({ lowerBound: this.state.lowerBound + 1 })}
                /> */}
                <NumericInput
                  value={this.state.lowerBound}
                  min={0}
                  max={this.state.upperBound}
                  step={1}
                  className="form-control"
                  onChange={e => this.setState({ lowerBound: e })}
                />
              </div>
            </div>
            <div className="row clearfix">
              <div className="numeric-input-text">
                <label htmlFor="upper-bound" className="float-right">
                  Upper Bound {'>=:'}{' '}
                </label>
              </div>
              <div className="numeric-input-control">
                {/* <NumericInput
                  min={this.state.lowerBound}
                  max={this.state.rowsData.length - 1}
                  value={this.state.upperBound}
                  className="form-control"
                  onChange={() => this.setState({ upperBound: this.state.upperBound - 1 })}
                /> */}
                <NumericInput
                  value={this.state.upperBound}
                  min={this.state.lowerBound}
                  max={this.state.rowsData.length > 0 ? this.state.rowsData.length - 1 : 0}
                  step={1}
                  className="form-control"
                  onChange={e => this.setState({
                    upperBound: e,
                    lowerBound: this.state.lowerBound > e ? e : this.state.lowerBound,
                  })}
                />
              </div>
            </div>
            <div className="clearfix">
              <FunctionBoxButtonGroup
                moveAppendToCodingBox={this.moveAppendToCodingBox}
                moveToColumns={this.moveToColumns}
                moveToRows={this.moveToRows}
                addToDefinitionModal={this.addToDefinitionModal}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
FunctionBoxCount.propTypes = {
  functionTitle: PropTypes.string,
  moveAppendToCodingBox: PropTypes.func,
  moveToRows: PropTypes.func,
  moveToColumns: PropTypes.func,
  addToDefinition: PropTypes.func,
  sampleWeightedValues: PropTypes.arrayOf(PropTypes.object),
  selectedTargets: PropTypes.arrayOf(PropTypes.object),
};
function mapStateToProps(state) {
  return {
    sampleWeightedValues: state.crosstab.FunctionBoxCountDataGridData,
  };
}

export default connect(mapStateToProps)(FunctionBoxCount);
